import { addHours, formatRelative, isAfter, isBefore } from 'date-fns';
import { sv } from 'date-fns/locale';

import { formatDate } from './format';

const formatRelativeLocale = {
  lastWeek: "'I' EEEE's'",
  yesterday: "'Igår'",
  today: "'Idag'",
  tomorrow: "'Imorgon'",
  nextWeek: "'På' EEEE",
  other: 'do MMM yyyy',
};

const locale = {
  ...sv,
  formatRelative: token => formatRelativeLocale[token],
};

export function formatRoundDate(date) {
  const currentYear = new Date().getFullYear();

  return formatRelative(date, new Date(), { locale })
    .replace(` ${currentYear}`, '')
    .replace('.', '');
}

export function roundState(startTime) {
  if (!startTime) {
    return '';
  }

  const start = new Date(startTime);
  const end = addHours(start, 2);
  const now = new Date();

  const finished = isAfter(now, end);
  const ongoing = isAfter(now, start) && isBefore(now, end);

  if (finished) {
    return ', avslutad';
  } else if (ongoing) {
    return ', pågår';
  } else {
    return `, start ${formatDate(start, 'HH:mm')}`;
  }
}
